import { render, staticRenderFns } from "./devolucao_origem.vue?vue&type=template&id=6f13ea08&"
import script from "./devolucao_origem.vue?vue&type=script&lang=js&"
export * from "./devolucao_origem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports